export default function BrazeIntegration() {
    const braze = require("@braze/web-sdk");
    window.braze = braze;

    // initialize the SDK
    braze.initialize('eba0f643-7874-4018-b212-32e7f1992845', {
        baseUrl: "sdk.au-01.braze.com",
        enableLogging: false, // set to `true` for debugging
        allowUserSuppliedJavascript: true, // set to `true` to support custom HTML messages
    });

    const params = new URLSearchParams(window.location.search);
    const encodedExtId = params.get("ext_id");

    if (encodedExtId) {
        localStorage.setItem("braze_ext_id", encodedExtId);
    }

    const storedExtId = localStorage.getItem("braze_ext_id");

    if (storedExtId) {
        const externalId = atob(storedExtId);
        braze.changeUser(externalId);
    }
    
}
